import { GenericFunction } from '../Functions';
import { saveData } from "./DataSave";


/**
 * Convert a DAG to a JSON save format
 * 
 * @param {DAG} dag DAG to save
 */
export function saveDAG(dag) {
  return dag.inverseDAG;
}


/**
 * Convert a NodeSet into a JSON save format
 * 
 * @param {NodeSet} nodes NodeSet containing all component-node mappings
 */
export function saveNodeSet(nodes) {
  return nodes.nodeToComponent;
}


/**
 * Convert a model function to a JSON save format
 * 
 * @param {Function} func Component function to save
 */
export function saveFunction(func) {
  if (func instanceof GenericFunction) {
    return {'label': func.label };
  } else {
    return null;
  }
}


/**
 * Convert an input mapping into a JSON save format
 * 
 * @param {Object} map InputMap to save
 */
export function saveInputMap(map) {
  return map.getMap();
}


/**
 * Convert an entire Component to a JSON save format
 * 
 * @param {Component} component Component to save
 */
export function saveComponent(component) {
  return {
    'label': component.label,
    'data': !component.method ? saveData(component.data) : null,
    'method': saveFunction(component.method),
    'inputMapping': saveInputMap(component.inputMapping),
    'scenarios': component.scenarios.map(s => saveInputMap(s))
  }
}


/**
 * Convert an entire Model to a JSON save format
 * 
 * @param {Model} model Model to save
 */
export function saveModel(model) {
  let savedComponent = [];

  for (let component of model.components) {
    savedComponent.push(saveComponent(component));
  }

  return {
    'label': model.label,
    'components': savedComponent,
    'dag': saveDAG(model.dag),
    'nodes': saveNodeSet(model.nodes)
  }
}